import useScrollDirection from '@/common/hooks/useScrollDirection/useScrollDirection';
import { StyledRightArrowIcon, StyledSubPageHeaderContainer } from './LayoutThree.styles';
import DateFilter from '../../shared/DateFilter/DateFilter';
import { Box, Button } from '@base-app';
import { LAYOUT_NUMBER } from './LayoutThree.types';
import { Variants } from '@/common/types';
import { ScrollDirection } from '@/common/types/ScrollDirection.type';
import { DateRangeSelection } from '@/common/components';
import { TFunction } from 'i18next';

interface ConsentedParticipantsSubHeaderProps {
  isNavSticky: boolean;
  storeEndDate: string | undefined;
  storeStartDate: string | undefined;
  selectedDateRange: DateRangeSelection | undefined;
  onDateRangeChange: (dateRange: DateRangeSelection) => void;
  onClick?: () => void;
  t: TFunction;
}

export const ConsentedParticipantsSubHeader = ({
  isNavSticky,
  storeEndDate,
  storeStartDate,
  selectedDateRange,
  onDateRangeChange,
  onClick,
  t,
}: ConsentedParticipantsSubHeaderProps): JSX.Element => {
  const { direction } = useScrollDirection();

  return (
    <StyledSubPageHeaderContainer
      isSticky={isNavSticky}
      css={{
        top: direction === ScrollDirection.DOWN ? 0 : '$stickyNav$height',
      }}
    >
      <Box
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          maxWidth: '$studyInsights$headerMaxWidth',
          width: '100%',
        }}
      >
        <DateFilter
          rangeTextStyles={{ fontSize: '24px' }}
          css={{ display: 'flex', flexDirection: 'row-reverse', gap: '$4' }}
          onDateRangeChange={onDateRangeChange}
          selectedDateRange={selectedDateRange}
          storeEndDate={storeEndDate}
          storeStartDate={storeStartDate}
          layout={LAYOUT_NUMBER}
        />
        <Button css={{ padding: '$1 $4', display: 'none' }} onClick={onClick} variant={Variants.SECONDARY}>
          {t('participant_recruitment.expand_graph_view')}
          <Box css={{ display: 'inline-flex' }}>
            <StyledRightArrowIcon />
          </Box>
        </Button>
      </Box>
    </StyledSubPageHeaderContainer>
  );
};
